import { STALE_TIME } from 'business/constants';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import { HttpError, RQAPICallWithData } from 'store/APIClient';

type BudgetSummary = {
    cpAmount: number;
    reAmount: number;
    total: number;
};

/** Returns BudgetSummary for selected Budget Proposal. [SIFAC] */
export const useGetSummary = (
    targetBudgetProposals: BudgetProposalT[],
    valueOrgChartFinanceFilter: string,
): UseQueryResult<BudgetSummary, HttpError> => {
    const queryParams = new URLSearchParams();
    const bpIds = targetBudgetProposals.map((bp) => bp.id);
    bpIds.forEach((bpId) => queryParams.append('bp_id', bpId.toString()));
    queryParams.append('org_chart_finance', valueOrgChartFinanceFilter);
    return useQuery({
        queryKey: ['budget_summary', bpIds, valueOrgChartFinanceFilter],

        queryFn: async () => {
            const response = await RQAPICallWithData<BudgetSummary>({
                endpoint: `budget/budget_proposals/summary?${queryParams}`,
                method: 'GET',
            });

            return response.content.data;
        },

        staleTime: STALE_TIME,
    });
};
